import { render, staticRenderFns } from "./BaseTitle.vue?vue&type=template&id=7939743c&scoped=true&"
var script = {}
import style0 from "./BaseTitle.vue?vue&type=style&index=0&id=7939743c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7939743c",
  null
  
)

export default component.exports